// extracted by mini-css-extract-plugin
var _1 = "TableRequestNoCell-modulecontainer__uOrNN";
export { _1 as "container" }
